import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgbDropdownButtonItem, NgbDropdownItem } from '@ng-bootstrap/ng-bootstrap';
import {
  ContextMenuComponent,
  MasterComponent,
  MasterDetailComponent,
  PanelComponent,
  PanelHeaderComponent,
  TitleComponent,
} from '@rocksoft/cdk';
import { Group } from '@rocksoft/security-sdk';
import { GroupListItemContainerComponent } from '@rocksoft/shared';

@Component({
  selector: 'era-group-list-view-ui',
  templateUrl: './group-list-view.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MasterDetailComponent,
    MasterComponent,
    PanelComponent,
    PanelHeaderComponent,
    TitleComponent,
    ContextMenuComponent,
    NgbDropdownButtonItem,
    NgbDropdownItem,
    RouterLink,
    GroupListItemContainerComponent,
  ],
})
export class GroupListViewComponent {
  readonly groups = input<Group[]>();
  public readonly editEnabled = input<boolean>();

  public readonly toggleEditEvent = output();
  public readonly addGroupEvent = output();
  public readonly deleteRequested = output<Group>();

  toggleEdit() {
    this.toggleEditEvent.emit();
  }

  addGroup() {
    this.addGroupEvent.emit();
  }
}
